import React from "react";

// HELPERS
import {createClassName} from "@helpers/utils";


export default class TextView extends React.PureComponent {
	state = {
		filled: false,
		focused: false,
	};

	render() {
		const {props, state} = this;
		const {style, id, name, label, placeholder, required, readOnly, hideRequiredSymbol, value, valid, tooltip, fullWidth} = props;
		const disabled = props.disabled === true;
		const classes = createClassName(props.className, {
			"TextView": true,
			"focus": state.focused,
			"disabled": disabled,
			"placeholder": !!placeholder,
			"filled": state.filled || !!value,
			"required": required === true,
			"tooltip": !!tooltip,
			"valid": valid === true,
			"invalid": valid === false,
			"full-width": fullWidth === true,
			// "resize-none": resize === "none",
			// "resize-both": !resize || resize === "both",
			// "resize-horizontal": resize === "horizontal",
			// "resize-vertical": resize === "vertical",
		});

		return (
			<div className={classes} style={style}>
				<label className="TextView-label">{(valid === false && props.invalidMessage) || label}</label>
				<textarea
					ref={ref => this.input = ref}
					className="TextView-input"
					id={id}
					name={name}
					placeholder={placeholder}
					value={value}
					required={required === true}
					disabled={disabled}
					readOnly={readOnly}
					onFocus={!disabled ? this._onFocus : undefined}
					onBlur={!disabled ? this._onBlur : undefined}
					onChange={!disabled ? this._onChange : undefined}
				/>
				{!!tooltip ?
					<TextViewTooltip text={tooltip}/>
					: valid === true ?
						<TextViewStatus icon="done"/>
						: required === true && !hideRequiredSymbol ?
							<TextViewStatus requiredSymbol/>
							: valid === false ?
								<TextViewStatus icon="error"/>
								: null}
			</div>
		);
	}

	// Internal methods
	_onFocus = ({target}) => {
		const {onFocus} = this.props;
		this.setState({focused: true}, onFocus ? () => onFocus(target.value) : undefined);
	};

	_onBlur = ({target}) => {
		const {onBlur} = this.props;
		this.setState({focused: false}, onBlur ? () => onBlur(target.value) : undefined);
	};

	_onChange = ({target}) => {
		const {onChange, disableEnterKey} = this.props;

		let newValue = target.value;
		if (disableEnterKey) {
			newValue = newValue.replace(/\n/g, "");
		}

		if (onChange) {
			onChange(newValue);
		}
	}
}


// PRIVATE COMPONENTS
function TextViewTooltip({text, onClick}) {
	return (
		<div className="TextView-tooltip">
			<div className="TextView-tooltip-icon">?</div>
			<div className="TextView-tooltip-text">{text}</div>
		</div>
	);
}

function TextViewStatus({icon, requiredSymbol}) {
	return (
		<div className="TextView-status">
			<div className={createClassName("material-icons", {
				"icon": !!icon,
				"required-symbol": requiredSymbol === true,
			})}>{requiredSymbol === true ? "*" : icon}</div>
		</div>
	);
}


// WEBPACK FOOTER //
// ./src/components/TextView/TextView.js